/**
 * Finds the largest integer font size in [minFontPx, maxFontPx] such that
 * measureScrollWidth(fontPx) <= availableWidth, matching a linear scan from
 * max down to min. If the text does not fit even at minFontPx, returns minFontPx.
 *
 * @param measureScrollWidth Called with each candidate font size; must reflect
 *   layout after that size is applied (caller typically mutates a hidden measure node).
 */
export function computeAutoFitFontPx(
  availableWidth: number,
  minFontPx: number,
  maxFontPx: number,
  measureScrollWidth: (fontPx: number) => number
): number {
  if (minFontPx > maxFontPx) {
    return maxFontPx;
  }

  if (availableWidth <= 0) {
    return maxFontPx;
  }

  if (measureScrollWidth(maxFontPx) <= availableWidth) {
    return maxFontPx;
  }

  if (measureScrollWidth(minFontPx) > availableWidth) {
    return minFontPx;
  }

  let lo = minFontPx;
  let hi = maxFontPx;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (measureScrollWidth(mid) <= availableWidth) {
      lo = mid;
    } else {
      hi = mid - 1;
    }
  }

  return lo;
}
